// extracted by mini-css-extract-plugin
export default {"fullWidth":"So-z","image":"To-z","lazyLoadPicture":"Uo-z","lazyLoadSpinner":"Vo-z","lazyLoadSpin":"Wo-z","lazyLoadImage":"Xo-z","hasStyledAspectRatio":"Yo-z"};